<template>
  <!-- -->
  <div class="defaultViewStyle">
    <list-page>
      <yq-empty v-if="dictionaryTypes.length === 0"/>
      <el-tabs v-model="activeName" v-else>
        <el-tab-pane v-for="(dic, i) in dictionaryTypes" :key="i" :name="dic.dictCode" :label="dic.dictName" style="height: 100%" lazy>
          <dictionary-list v-if="dic.treeType === 0" :diction-setting="dic"/>
          <dictionary-tree v-else-if="dic.treeType === 1"  :diction-setting="dic"/>
<!--          <dictionary-dynamic v-else-if="dic.treeType === 2"  :diction-setting="dic"/>-->
        </el-tab-pane>
      </el-tabs>
    </list-page>
  </div>

</template>

<script>
import ListPage from "@/components/h5/layout/ListPage";
import dictionaryApi from "@/api/normal/sys/dictionaryApi";
import DictionaryList from "./DictionaryList";
import DictionaryTree from "./DictionaryTree";
import dictionaryDynamic from "./DictionaryDynamic.vue";
export default {
  name: "",
  components: {
    ListPage, DictionaryList, DictionaryTree, dictionaryDynamic
  },
  data() {
    return {
      activeName: "",
      dictionaryTypes: [],
    };
  },
  created() {
    // 查询字典分类
    dictionaryApi.queryDictionaryTypes().then(list => {
      this.dictionaryTypes = list;
      //如果有多个菜单，选中选一个
      if (list.length > 0) {
        this.activeName = list[0].dictCode;
      }
    });
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tabs";
</style>